const brandGreen = {
  50: "rgb(155,234,191)",
  100: "rgb(129,217,165)",
  200: "rgb(103,200,139)",
  300: "rgb(77,183,113)",
  400: "rgb(51,166,87)",
  500: "rgb(25,149,61)",
  600: "rgb(20,129,53)",
  700: "rgb(15,109,45)",
  800: "rgb(10,89,37)",
  900: "rgb(5,69,29)",
  A100: "rgb(185,246,202)",
  A200: "rgb(105,240,174)",
  A400: "rgb(0,230,118)",
  A700: "rgb(0,200,83)",
};

export default brandGreen;
